import { render, staticRenderFns } from "./OgSimpleDateInput.vue?vue&type=template&id=d6efb9ea&scoped=true&"
import script from "./OgSimpleDateInput.vue?vue&type=script&lang=js&"
export * from "./OgSimpleDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6efb9ea",
  null
  
)

export default component.exports